import React, { useEffect, useState } from "react";
import { atom, useRecoilState } from "recoil";
import dayjs from "dayjs";
import LineBtn from "../../components/Button/LineBtn";
import LineBox from "../../components/DefaultStyles/LineBox";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import { TotalCount } from "./UserInfo";
import Blank from "../../components/DefaultStyles/Blank";
import CommentModal from "../../components/pages/Users/UserDetail/CommentModal/CommentModal";
import { toast } from "react-toastify";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import Loader from "../../components/DefaultStyles/Loader";
import { useNavigate } from "react-router-dom";
import { getThousandComma } from "../../Api/ApiCommon";
import { getEllipsis } from "../../ApiTS/ApiCommonTS";
import CommentFilter from "../../components/pages/Users/Comment/CommentFilter";

export interface ICommentInfo {
  commentId?: string;
  uid: string;
  name: string;
  nickname: string;
  partyId?: string;
  tag?: string;
  content?: string;
  writeDay?: string;
  writer?: string;
  servsubsid?: number;
  duedate?: string;
  iscomp?: number;
}

export const commentPageState = atom<number>({
  key: "commentPageState",
  default: 0,
});

export const commentFilterState = atom<{ type: string; value: string }>({
  key: "commentFilterState",
  default: { type: "", value: "" },
});

export const commentTagFilterState = atom<string>({
  key: "commentTagFilterState",
  default: "",
});

export default function Comment() {
  const navigate = useNavigate();
  const [savedPage, setSavedPage] = useRecoilState<number>(commentPageState);

  const [page, setPage] = useState(savedPage);
  const [filter, setFilter] = useRecoilState(commentFilterState);
  const [tagFilter, setTagFilter] = useRecoilState(commentTagFilterState); // 코멘트 태그 필터
  const [commentToastModal, setCommentToastModal] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [commentData, setCommentData] = useState<ICommentInfo>({
    commentId: "",
    partyId: "",
    tag: "",
    content: "",
    writeDay: "",
    writer: "",
    name: "",
    nickname: "",
    uid: "",
    servsubsid: 0,
    duedate: "",
    iscomp: 0,
  });

  console.log(filter);

  const { response, fetchData, loading } = useApi({
    method: "get",
    url:
      `comment?page=${page}&size=10` +
      (filter?.value !== "" ? `&${filter?.type}=${filter?.value}` : ``) +
      (tagFilter !== "" ? `&category=${tagFilter}` : ``),
  });

  const tableHead = [
    "NO",
    "UID_이름_닉네임",
    "PID",
    "태그(구분)",
    "내용",
    "해결 기한",
    "해결 여부",
    "작성 일시",
    "작성자",
    "상세",
  ];

  useEffect(() => {
    setSavedPage(page);
  }, [page]);

  useEffect(() => {
    if (filter.value !== "") {
      setPage(0);
    }
  }, [filter.value]);

  useEffect(() => {
    if (commentToastModal) {
      fetchData({
        method: "get",
        url:
          `comment?page=${page}&size=10` +
          (filter?.value !== "" ? `&${filter?.type}=${filter?.value}` : ``) +
          (tagFilter !== "" ? `&category=${tagFilter}` : ``),
      });

      toast.success("코멘트가 추가되었습니다.", {
        onClose: () => setCommentToastModal(false),
      });
    }
  }, [commentToastModal]);

  console.log(response?.data?.items);

  return (
    <>
      <PageTitle title="코멘트" />

      <CommentFilter
        pageResetEvent={() => setPage(0)}
        setFilter={setFilter}
        setTagFilter={setTagFilter}
        fetchData={() =>
          fetchData({
            method: "get",
            url:
              `comment?page=${page}&size=10` +
              (filter?.value !== ""
                ? `&${filter?.type}=${filter?.value}`
                : ``) +
              (tagFilter !== "" ? `&category=${tagFilter}` : ``),
          })
        }
      />

      <Blank blankHeight={12} />

      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={715}>
          <>
            {response?.data?.items?.map((d: ICommentInfo) => {
              return (
                <TableBody key={d?.commentId}>
                  <TableBodyItem>{d?.commentId}</TableBodyItem>
                  <TableBodyItem
                    clickable={true}
                    onClick={() => {
                      setSavedPage(page);
                      navigate(`/users/info/${d?.uid}`);
                    }}
                    isKeepAll={true}
                  >
                    {d?.uid}_{d?.name}_{d?.nickname}
                  </TableBodyItem>
                  <TableBodyItem
                    clickable={d?.partyId === "0" || !d?.partyId ? false : true}
                    onClick={() => {
                      if (!(d?.partyId === "0" || !d?.partyId)) {
                        setSavedPage(page);
                        navigate(`/party/info/${d?.partyId}`);
                      }
                    }}
                  >
                    {d?.partyId === "0" ? "-" : d?.partyId ?? "-"}
                  </TableBodyItem>
                  <TableBodyItem>{d?.tag}</TableBodyItem>
                  <TableBodyItem>{getEllipsis(d?.content!, 18)}</TableBodyItem>
                  <TableBodyItem
                    style={{
                      textDecoration:
                        d?.iscomp === 1 ? "line-through" : "unset",
                    }}
                  >
                    {d?.duedate ?? "해당 없음"}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.iscomp === 2
                      ? "해당 없음"
                      : d?.iscomp === 1
                      ? "해결 완료"
                      : d?.iscomp === 0
                      ? "미해결"
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem>
                    {dayjs(d?.writeDay).format("YYYY-MM-DD HH:mm")}
                  </TableBodyItem>
                  <TableBodyItem>{d?.writer}</TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText="상세"
                      btnClickEvent={() => {
                        setCommentData(d);
                        setCommentModal(true);
                      }}
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <ExcelDownload
        disabled={response?.data?.items?.length < 1}
        tableHead={tableHead}
        pushedData={(e: any) => {
          return [
            e.commentId,
            `${e?.uid}_${e?.name}_${e?.nickname}`,
            e.partyId,
            e.tag,
            e.content,
            dayjs(e.writeDay)?.format("YYYY-MM-DD HH:mm"),
            e.writer,
          ];
        }}
        dataUrl={
          `comment?page=${page}&size=1000` +
          (filter?.value !== "" ? `&${filter?.type}=${filter?.value}` : ``) +
          (tagFilter !== "" ? `&category=${tagFilter}` : ``)
        }
        title="코멘트"
      />

      {/* 코멘트 보기 모달 */}
      {commentModal && (
        <CommentModal
          closeEvent={() => setCommentModal(false)}
          confirmEvent={() =>
            fetchData({
              method: "get",
              url:
                `comment?page=${page}&size=10` +
                (filter?.value !== ""
                  ? `&${filter?.type}=${filter?.value}`
                  : ``) +
                (tagFilter !== "" ? `&category=${tagFilter}` : ``),
            })
          }
          commentData={commentData}
          type="view"
        />
      )}

      {loading && <Loader />}
    </>
  );
}
